class TC_AccountTypeChecker {
    constructor (playerInstance, channelsInstance) {
        this.player = playerInstance;
        this.channels = channelsInstance;
        this.user = {
            isVip: !!parseInt(Cookies.get('ice-vip'), 10),
            login: Cookies.get('ice-login'),
            token: Cookies.get('ice-token')
        };
        this.isSafariDesktop = window.safari !== undefined;

        setTimeout(() => {
            this.accountTypeCheck();
        }, 30000);
    }

    accountTypeCheck () {
        let timestampParam = '';

        if (this.isSafariDesktop) {
            timestampParam = '?v=' + Math.round(+Date.now() / 7500);
        }

        $.post('https://api.' + window.CSITE.appDomain + '/v2/check' + timestampParam, {
            username: this.user.login,
            token: this.user.token,
        }).done(res => {
            if (res && res.license_count) {
                this.updateState(res.license_count);
            }

            setTimeout(() => {
                this.accountTypeCheck();
            }, 60 * 1000);
        });
    }

    updateState (licensesCount) {
        let isVip = licensesCount > 0;

        if (typeof licensesCount !== 'number') {
            return;
        }

        if (this.user.isVip === isVip) {
            return;
        }

        if (this.user.isVip && !isVip) {
            this.paidToFreeTransition();
        } else if (!this.user.isVip && isVip) {
            this.freeToPaidTransition();
        }
    }

    paidToFreeTransition () {
        // change user state to free
        this.user.isVip = false;
        this.channels.user.isVip = false;
        this.player.user.isVip = false;
        window.location.href = window.CSITE.baseUrlWithLang + 'subscribe/';
    }

    freeToPaidTransition () {
        // change user state to free
        this.user.isVip = true;
        this.channels.user.isVip = true;
        this.player.user.isVip = true;
        // reload channel
        this.player.loadChannel(this.player.currentChannel.id, this.player.playing);
    }
}
